import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { Title } from 'react-admin';
import BetaRequestsPanel from '../Connectors/BetaRequestsPanel';
import { LastBillingAccounts } from './LastBillingAccounts';
import { LastUsers } from './LastUsers';
import { InactiveBillingAccounts } from './InactiveBillingAccounts';

export const Home = (_props: any) => {
	return (
		<Box sx={{ mt: 2 }}>
			<Title title="Accueil" />
			<Typography variant="h5" gutterBottom>
				Tableau de bord
			</Typography>

			{/* En premier : c'est le seul panneau qui appelle une ACTION de notre part
			    — une demande en attente bloque quelqu'un. Le reste est de
			    l'observation. */}
			<BetaRequestsPanel />

			{/* Ce qui entre (créations, inscriptions), puis ce qui s'éteint. Chaque
			    carte renvoie vers la liste correspondante, filtrée comme elle. */}
			<Grid container spacing={2} sx={{ mt: 1 }}>
				<Grid item xs={12} md={6}>
					<LastBillingAccounts />
				</Grid>
				<Grid item xs={12} md={6}>
					<LastUsers />
				</Grid>
				<Grid item xs={12}>
					<InactiveBillingAccounts />
				</Grid>
			</Grid>
		</Box>
	);
};
